export enum RouteStatus {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Pending = 3
}

export const RouteStatusMapping: Record<RouteStatus, string> = {
  [RouteStatus.Unknown]: 'Unknown',
  [RouteStatus.Active]: 'Active',
  [RouteStatus.Inactive]: 'Inactive',
  [RouteStatus.Pending]: 'Pending'
};
